<app-ds-modal-shell [showHeader]="false" size="md" [title]="'private_profile_modal_title' | translate">
<div class="private-profile-modal" modalBody>
  <div class="modal-icon">
    <img src="assets/images/Home/rhyno.png" alt="{{ 'auto_rhyno' | translate }}" />
  </div>

  <h2 class="modal-title">
    {{ "private_profile_modal_title" | translate }}
  </h2>

  <p class="modal-description">
    {{ "private_profile_modal_description" | translate }}
  </p>

  <div class="benefits-list">
    <div class="benefit-item">
      <mat-icon class="benefit-icon">visibility</mat-icon>
      <span>{{ "private_profile_benefit_1" | translate }}</span>
    </div>
    <div class="benefit-item">
      <mat-icon class="benefit-icon">payments</mat-icon>
      <span>{{ "private_profile_benefit_2" | translate }}</span>
    </div>
    <div class="benefit-item">
      <mat-icon class="benefit-icon">trending_up</mat-icon>
      <span>{{ "private_profile_benefit_3" | translate }}</span>
    </div>
  </div>
</div>

<div class="modal-actions" modalActions>
  <app-ds-button tone="secondary" class="btn-secondary" (pressed)="close()">
    {{ "private_profile_later" | translate }}
  </app-ds-button>
  <app-ds-button tone="primary" class="btn-primary" (pressed)="goToProfile()">
    <mat-icon>edit</mat-icon>
    {{ "private_profile_complete_profile" | translate }}
  </app-ds-button>
</div>
</app-ds-modal-shell>
